import { Action, Reducer } from 'redux';
import {
  AddressTypeState,
  AddressTypeTypes,
  AddressTypeActionTypes
} from './addressTypeTypes';

export const INITIAL_STATE: AddressTypeState = {
  addressType: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const addressTypeReducer: Reducer<AddressTypeState> = (
  state: AddressTypeState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as AddressTypeActionTypes;
  switch (actionTypes.type) {
    case AddressTypeTypes.GET_ADDRESS_TYPE:
      return {
        ...state,
        addressType: { ...state.addressType, isLoading: true }
      };
    case AddressTypeTypes.GET_ADDRESS_TYPE_PUBLIC:
      return {
        ...state,
        addressType: { ...state.addressType, isLoading: true }
      };
    case AddressTypeTypes.SAVE_ADDRESS_TYPE:
      return {
        ...state,
        addressType: {
          ...state.addressType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case AddressTypeTypes.SAVE_ADDRESS_TYPE_PUBLIC:
      return {
        ...state,
        addressType: {
          ...state.addressType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case AddressTypeTypes.RESET_REDUCER_ADDRESS_TYPE:
      return {
        ...state,
        addressType: INITIAL_STATE.addressType
      };
    default:
      return state;
  }
};

export default addressTypeReducer;
